<template lang="pug">
v-row(align="center" justify="center").fill-height.ma-0
    v-icon(dark) {{ icon }}
</template>

<script lang="ts">
import Vue from "vue"
import { mdiAccountCircleOutline } from "@mdi/js"
import { mdiAccountGroupOutline } from "@mdi/js"
export default Vue.extend({
  name: "AvatarPlaceholder",
  props: {
    avatarType: {
      type: String,
      default: "GroupMember",
      validator: (val: string) => ["GroupMember", "Group"].includes(val),
    },
  },
  computed: {
    icon() {
      return this.avatarType === "Group"
        ? mdiAccountGroupOutline
        : mdiAccountCircleOutline
    },
  },
})
</script>
